var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import 'rxjs/add/observable/fromPromise';
import { of } from 'rxjs/observable/of';
import { environment } from '@env/environment';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Headers, Http } from '@angular/http';
import { catchError, map } from 'rxjs/operators';
import { ServerType } from '@app/games/models/server-type.model';
import { _throw } from 'rxjs/observable/throw';
import * as amplitude from 'amplitude-js';
import { Logger } from '@app/core/logger.service';
import { BalanceService } from '@app/core/balance.service';
var logger = new Logger('@core:authentication.service.ts');
var CURRENCY_USD = 'usd';
var credentialsKey = 'credentials';
/**
 * Provides a base for authentication workflow.
 * The Credentials interface as well as login/logout methods should be replaced with proper implementation.
 */
var AuthenticationService = /** @class */ (function () {
    function AuthenticationService(http, document, balanceService) {
        this.http = http;
        this.document = document;
        this.balanceService = balanceService;
        this.demoBalance = 500000;
        this.realEdgBalance = 0;
        this.bonusEdgBalance = 0;
        this.convertedBalance = 0;
        this.convertedCurrency = CURRENCY_USD;
        this._credentials = null;
        this._userInfo = null;
        this._credentialsSubject = new BehaviorSubject(null);
        this._userInfoSubject = new BehaviorSubject(null);
        this.credentials$ = this._credentialsSubject.asObservable();
        this.userInfo$ = this._userInfoSubject.asObservable();
        this.privateKey = null;
        this.guestUsername = null;
        this.guestEmail = null;
        this.affiliateCode = null;
        this.affiliateTrackerId = null;
        this.referralCode = null;
        this.guestTimer = null;
        this.guestLost = false;
        this.guestWon = false;
        this.guestTimed = false;
        this.refreshingToken = false;
        this.refreshingTries = 0;
        this.server = ServerType.Server;
        this._gameMode = new BehaviorSubject(this.server);
        this.onModeChanged$ = this._gameMode.asObservable();
        var savedCredentials = sessionStorage.getItem(credentialsKey) || localStorage.getItem(credentialsKey);
        if (savedCredentials) {
            this._credentials = JSON.parse(savedCredentials);
            this._credentialsSubject.next(this._credentials);
        }
        if (environment.version === '(dev)') {
            var savedPrivateKey = sessionStorage.getItem('pp') || localStorage.getItem('pp');
            if (savedPrivateKey) {
                this.privateKey = new Buffer(JSON.parse(savedPrivateKey), 'hex');
            }
        }
    }
    AuthenticationService.prototype.stopGuestTimer = function () {
        if (this.guestTimer) {
            clearTimeout(this.guestTimer);
        }
    };
    AuthenticationService.prototype.setTrackerCode = function (code) {
        localStorage.setItem('__edg-affiliate', JSON.stringify(code));
        this.affiliateTrackerId = code;
    };
    AuthenticationService.prototype.getTrackerCode = function () {
        var savedAffiliateCode = sessionStorage.getItem('__edg-affiliate') || localStorage.getItem('__edg-affiliate');
        if (savedAffiliateCode) {
            this.affiliateTrackerId = JSON.parse(savedAffiliateCode);
        }
        return this.affiliateTrackerId;
    };
    /**
     * Authenticates the user.
     * @param {LoginContext} context The login parameters.
     * @return {Observable<any>} The user credentials.
     */
    AuthenticationService.prototype.login = function (context) {
        var _this = this;
        return this.http
            .post('/api/auth/login', {
            username: context.username,
            password: context.password,
            'g-recaptcha-response': context['g-recaptcha-response'],
            answer: context.answer,
            question: context.question,
        })
            .pipe(map(function (response) {
            var item = response.json();
            if (response.status === 200) {
                var credentials = {
                    username: item.token.username,
                    refreshToken: item.token.refreshToken,
                    accessToken: item.token.accessToken,
                    expiresAt: item.token.expiresIn,
                };
                _this.setCredentials(credentials, true);
                _this.setUserInfo(item.user);
                _this.setPrivateKey(item.user.privateKey, false);
                _this.stopGuestTimer();
                return credentials;
            }
            return response;
        }));
    };
    /**
     * @param gameId
     */
    AuthenticationService.prototype.requestBonus = function (gameId) {
        if (!this.credentials) {
            this._userInfoSubject.next(null);
            return of(null);
        }
        var headers = new Headers();
        headers.append('Authorization', this.credentials.accessToken);
        return this.http.post('/api/game-bonus/' + gameId, {}, {
            headers: headers,
        });
    };
    /**
     * @param email
     */
    AuthenticationService.prototype.regEmail = function (email) {
        return this.http
            .post('/api/auth/reg-email', {
            email: email,
            referral: this.getReferral(),
        })
            .pipe(map(function (response) {
            var item = response.json();
            if (response.status === 200) {
                return item;
            }
            return response.json();
        }));
    };
    AuthenticationService.prototype.getReferral = function () {
        try {
            return localStorage.getItem('edg-ref');
        }
        catch (e) {
            return null;
        }
    };
    AuthenticationService.prototype.setReferral = function (ref) {
        try {
            localStorage.setItem('edg-ref', ref);
        }
        catch (e) {
            //
        }
    };
    /**
     * Downloads profile info.
     * @returns {Observable<Auth0UserModel>}
     */
    AuthenticationService.prototype.getUserInfo = function () {
        var _this = this;
        if (!this.credentials) {
            this._userInfoSubject.next(null);
            return of(null);
        }
        var headers = new Headers();
        headers.append('Authorization', this.credentials.accessToken);
        var ts = Math.round(new Date().getTime() / 1000);
        return this.http
            .get("/api/auth?ts=" + ts, {
            headers: headers,
        })
            .pipe(map(function (response) {
            _this.setUserInfo(response.json());
            return response.json();
        }), catchError(function (e) {
            if (e.status === 401) {
                _this.logout().subscribe();
            }
            return _throw(e);
        }));
    };
    /**
     * Changes users password.
     * @param {PasswordContext} context
     * @returns {Observable<any>}
     */
    AuthenticationService.prototype.changePassword = function (context) {
        if (!this.credentials) {
            return of(null);
        }
        var headers = new Headers();
        headers.append('Authorization', this.credentials.accessToken);
        return this.http
            .patch('/api/auth/change-password', context, {
            headers: headers,
        })
            .pipe(map(function (response) {
            return response.json();
        }));
    };
    AuthenticationService.prototype.deleteAccount = function () {
        if (!this.credentials) {
            return of(null);
        }
        var headers = new Headers();
        headers.append('Authorization', this.credentials.accessToken);
        return this.http
            .delete('/api/auth/close-account', {
            headers: headers,
        })
            .pipe(map(function (response) {
            return response.json();
        }));
    };
    /**
     * Confirms users email.
     * @param {string} token
     * @returns {Observable<any>}
     */
    AuthenticationService.prototype.confirmEmail = function (token) {
        return this.http
            .post('/api/auth/confirm-email', {
            token: token,
        })
            .pipe(map(function (response) {
            return response.json();
        }));
    };
    AuthenticationService.prototype.phoneVerificationRequest = function (phone, captcha) {
        if (!this.credentials) {
            return of(null);
        }
        var headers = new Headers();
        headers.append('Authorization', this.credentials.accessToken);
        return this.http.post('/api/auth/phone/request', {
            phone: phone,
            'g-recaptcha-response': captcha,
        }, {
            headers: headers,
        });
    };
    AuthenticationService.prototype.phoneVerificationCheck = function (code) {
        if (!this.credentials) {
            return of(null);
        }
        var headers = new Headers();
        headers.append('Authorization', this.credentials.accessToken);
        return this.http
            .post('/api/auth/phone/validate', {
            code: code,
        }, {
            headers: headers,
        })
            .pipe(map(function (response) {
            return response.json();
        }));
    };
    AuthenticationService.prototype.phoneVerificationCancel = function () {
        if (!this.credentials) {
            return of(null);
        }
        var headers = new Headers();
        headers.append('Authorization', this.credentials.accessToken);
        return this.http
            .post('/api/auth/phone/cancel', {}, {
            headers: headers,
        })
            .pipe(map(function (response) {
            return response.json();
        }));
    };
    /**
     * Requests password reset.
     * @param {string} email
     * @param {string} captcha
     * @returns {Observable<any>}
     */
    AuthenticationService.prototype.requestPasswordReset = function (email, captcha) {
        return this.http
            .post('/api/auth/request-password-reset', {
            email: email,
            'g-recaptcha-response': captcha,
        })
            .pipe(map(function (response) {
            return response.json();
        }));
    };
    /**
     * Validates password reset token.
     * @param {string} token
     * @returns {Observable<any>}
     */
    AuthenticationService.prototype.validatePasswordResetToken = function (token) {
        return this.http
            .post('/api/auth/validate-password-reset-token', {
            token: token,
        })
            .pipe(map(function (response) {
            return response.json();
        }));
    };
    /**
     * Resets users password.
     * @returns {Observable<any>}
     * @param context
     */
    AuthenticationService.prototype.resetPassword = function (context) {
        return this.http.post('/api/auth/reset-password', context).pipe(map(function (response) {
            return response.json();
        }));
    };
    /**
     * Changes user data.
     * @param {EditUserContext} context
     * @returns {Observable<any>}
     */
    AuthenticationService.prototype.changeData = function (context) {
        if (!this.credentials) {
            return of(null);
        }
        var headers = new Headers();
        headers.append('Authorization', this.credentials.accessToken);
        return this.http
            .patch('/api/auth/change-data', context, {
            headers: headers,
        })
            .pipe(map(function (response) {
            return response.json();
        }));
    };
    /**
     * @param {RegistrationContext} context
     * @param keyObj
     * @returns {Observable<any>}
     */
    AuthenticationService.prototype.createAccount = function (context, keyObj) {
        var _this = this;
        var tracker = this.getTrackerCode();
        if (tracker) {
            context.trackingId = tracker;
        }
        return this.http.post('/api/auth/register', context).pipe(map(function (response) {
            var item = response.json();
            if (response.status === 201) {
                var credentials = {
                    username: item.token.username,
                    refreshToken: item.token.refreshToken,
                    accessToken: item.token.accessToken,
                    expiresAt: item.token.expiresIn,
                };
                _this.setCredentials(credentials, true);
                _this.setUserInfo(item.user);
                _this.stopGuestTimer();
            }
            return response;
        }));
    };
    AuthenticationService.prototype.createAccountKYC = function (context) {
        var headers = new Headers();
        headers.append('Authorization', this.credentials.accessToken);
        return this.http.post('/api/auth/register-kyc', context, {
            headers: headers,
        });
    };
    AuthenticationService.prototype.createAccountOld = function (context) {
        var headers = new Headers();
        headers.append('Authorization', this.credentials.accessToken);
        return this.http.post('/api/auth/register-old', context, {
            headers: headers,
        });
    };
    /**
     * @returns {Observable<Response>}
     */
    AuthenticationService.prototype.resendEmailConfirmation = function () {
        if (!this.credentials) {
            return of(null);
        }
        var headers = new Headers();
        headers.append('Authorization', this.credentials.accessToken);
        return this.http.post('/api/auth/resend-confirmation-email', {}, {
            headers: headers,
        });
    };
    /**
     * Logs out the user and clear credentials.
     * @return {Observable<boolean>} True if the user was logged out successfully.
     */
    AuthenticationService.prototype.logout = function () {
        this.intercom(false);
        // Customize credentials invalidation here.
        this.setCredentials(null, true);
        this._userInfo = null;
        this.guestUsername = null;
        amplitude.getInstance().setUserId(null);
        return of(true);
    };
    /**
     * Refreshes expired access token.
     * @param {RefreshTokenContext} context
     * @returns {Promise<void>}
     */
    AuthenticationService.prototype.refreshToken = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.http
                        .post('/api/auth/refresh-token', context)
                        .pipe(map(function (response) {
                        _this.refreshingToken = false;
                        _this.refreshingTries = 0;
                        if (response.status === 200) {
                            var credentials = response.json();
                            _this.setCredentials(credentials, true);
                            _this.getUserInfo().subscribe(function () { }, function () { });
                        }
                    }), catchError(function (err) {
                        if (err.status === 401) {
                            _this._credentials = null;
                            _this._credentialsSubject.next(null);
                            sessionStorage.removeItem(credentialsKey);
                            localStorage.removeItem(credentialsKey);
                            _this.refreshingTries = 0;
                        }
                        return _throw(err);
                    }))
                        .toPromise()];
            });
        });
    };
    /**
     * Tries to refresh accessToken.
     */
    AuthenticationService.prototype.tryRefreshToken = function () {
        var _this = this;
        if (this.isTokenExpired() && !this.refreshingToken && this.hasCredentials()) {
            this.refreshingToken = true;
            (function () { return __awaiter(_this, void 0, void 0, function () {
                var e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.refreshToken({
                                    email: this._credentials.username,
                                    refreshToken: this._credentials.refreshToken,
                                })];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            e_1 = _a.sent();
                            this.refreshingToken = false;
                            this.refreshingTries += 1;
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); })();
        }
    };
    /**
     * Checks if credentials are available.
     * @returns {Credentials | any | string}
     */
    AuthenticationService.prototype.hasCredentials = function () {
        return this._credentials && this._credentials.username && this._credentials.refreshToken;
    };
    /**
     * Checks if access token is expired.
     * @returns {boolean}
     */
    AuthenticationService.prototype.isTokenExpired = function () {
        return this._credentials && new Date().getTime() >= this._credentials.expiresAt;
    };
    /**
     * Checks is the user is authenticated.
     * @return {boolean} True if the user is authenticated.
     */
    AuthenticationService.prototype.isAuthenticated = function () {
        return !!this.credentials;
    };
    Object.defineProperty(AuthenticationService.prototype, "credentials", {
        /**
         * Gets the user credentials.
         * @return {Credentials} The user credentials or null if the user is not authenticated.
         */
        get: function () {
            if (this.refreshingTries < 5) {
                this.tryRefreshToken();
            }
            return this.isTokenExpired() ? null : this._credentials;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthenticationService.prototype, "userInfo", {
        /**
         * Return user info, but only if credentials still valid.
         * @returns {any | null}
         */
        get: function () {
            if (!this.credentials) {
                return null;
            }
            return this._userInfo;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Checks if user credentials are set.
     * @returns {Observable<boolean>}
     */
    AuthenticationService.prototype.validate = function () {
        if (!this.credentials) {
            this.intercom(false);
            this._userInfoSubject.next(null);
            return of(false);
        }
        else {
            return of(true);
        }
    };
    /**
     * Sets the user credentials.
     * The credentials may be persisted across sessions by setting the `remember` parameter to true.
     * Otherwise, the credentials are only persisted for the current session.
     * @param {Credentials=} credentials The user credentials.
     * @param {boolean=} remember True to remember credentials across sessions.
     */
    AuthenticationService.prototype.setCredentials = function (credentials, remember) {
        if (credentials) {
            credentials.expiresAt = credentials.expiresAt * 1000 + new Date().getTime();
        }
        this._credentials = credentials || null;
        this._credentialsSubject.next(this._credentials);
        this.validate();
        if (credentials) {
            var storage = remember ? localStorage : sessionStorage;
            storage.setItem(credentialsKey, JSON.stringify(credentials));
        }
        else {
            sessionStorage.removeItem(credentialsKey);
            localStorage.removeItem(credentialsKey);
        }
    };
    AuthenticationService.prototype.setPrivateKey = function (privateKey, remember) {
        this.privateKey = new Buffer(privateKey, 'hex');
        // if (environment.version === '(dev)') {
        if (this.privateKey) {
            var storage = remember ? localStorage : sessionStorage;
            storage.setItem('pp', JSON.stringify(this.privateKey));
        }
        else {
            sessionStorage.removeItem('pp');
            localStorage.removeItem('pp');
        }
        // }
    };
    /**
     * @param info
     */
    AuthenticationService.prototype.setUserInfo = function (info) {
        if (info.privateKey) {
            this.setPrivateKey(info.privateKey, false);
        }
        // if (info) {
        /*const mode = localStorage.getItem('mode') as ServerType;
          if (mode && mode !== this.server) {
            this.setMode(mode);
          }*/
        // this.setMode(ServerType.Main);
        // }
        this._userInfo = info;
        this.intercom(true);
        this._userInfoSubject.next(this.userInfo);
        try {
            amplitude.getInstance().setUserId(info._id);
            amplitude.getInstance().setUserProperties({
                Email: info.email,
                Username: info.username,
                Verified: info.emailVerified ? 'yes' : 'no',
                KYC: info.verified === 'true' ? 'yes' : 'no',
                Chat: info.chat.muted ? 'off' : 'on',
                VIP: info.vip ? 'yes' : 'no',
            });
        }
        catch (e) {
            logger.error(e);
        }
    };
    AuthenticationService.prototype.intercom = function (state) {
        if (!state) {
            window.Intercom('shutdown');
            window.Intercom('boot', {
                name: null,
            });
        }
        else {
            var name_1 = null;
            if (this._userInfo.firstName && this._userInfo.lastName) {
                name_1 = (this._userInfo.firstName + " " + this._userInfo.lastName).trim();
            }
            window.Intercom('boot', {
                name: name_1,
                user_id: this._userInfo._id,
                user_hash: this._userInfo.user_hash,
                email: this._userInfo.email,
                Stage: this._userInfo.verified,
                Nickname: this._userInfo.username,
                App: 'Casino Website',
            });
        }
    };
    AuthenticationService.prototype.isMainServer = function () {
        return this.server === ServerType.Main;
    };
    AuthenticationService.prototype.isTestServer = function () {
        return this.server === ServerType.Server;
    };
    AuthenticationService.prototype.setMode = function (mode, reloadUser) {
        if (reloadUser === void 0) { reloadUser = false; }
        this.server = mode;
        if (this.isTestServer()) {
            this.demoBalance = 500000;
        }
        if (reloadUser) {
            this.getUserInfo().subscribe(function () { }, function () { });
        }
        localStorage.setItem('mode', this.server);
        this._gameMode.next(this.server);
    };
    AuthenticationService.prototype.isVerificationPending = function () {
        if (!this.userInfo) {
            return false;
        }
        return this.userInfo.verified === 'pending' || this.userInfo.verified === 'consider';
    };
    AuthenticationService.prototype.isVerificationDeclined = function () {
        if (!this.userInfo) {
            return false;
        }
        return this.userInfo.verified === 'declined' || this.userInfo.verified === 'false';
    };
    AuthenticationService.prototype.isImpersonated = function () {
        if (this.credentials) {
            return this.credentials.impersonated;
        }
        return false;
    };
    return AuthenticationService;
}());
export { AuthenticationService };



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/authentication/authentication.service.ts.pre-build-optimizer.js